export const version = "logger/5.0.9";
//# sourceMappingURL=_version.js.map